import "jquery-validation";
import { WebAppUtils, FeedbackManager, RecaptchaManager, DefaultCookieControlManager } from "flowli.web.common.client";
import { tns } from "tiny-slider/src/tiny-slider";

declare global {
    interface Window {
      

        //Register functions to be called when application will be ready.
        //Register functions to be called when application will be ready.
        //This is very useful because not all scripts are required to be in base class.
        //page specific scripts can register and wait for application to be complete first.
        OnApplicationReady: (() => void)[];
    }
}

class Application {
    public Init() {
        if (window.location.href.indexOf("/cache") > -1) {
            (async () => {
                const { cacheManager } = await import('flowli.web.common.client');
                cacheManager.Init();
            })();
        }

        const recaptchaManager = new RecaptchaManager();
        recaptchaManager.init();

        const feedbackManager = new FeedbackManager();
        feedbackManager.Init();

        const cookieManager = new DefaultCookieControlManager(window["CookieControlResources"],
            ["JSESSIONID", "PHPSESSID", "piwik_ignore", "MATOMO_SESSID", "mtm_consent", "mtm_cookie_consent", "_pk_testcookie", "pendingProductOrder", "ps_checkout_stage",
                "*InteractedMessages*", "fl_member_info", "purchasedSubscriptions", "rwbypass", "ps_messages_ignored"],
            ['_ga', '_gid', '_gat', '__utma', '__utmt', '__utmb', '__utmc', '__utmz', '__utmv', '_matherSegments', '_pk*', "IpLocation", "ai_user", "ai_session", "_sp*"],
            [],
            []);
        cookieManager.Init();

        this.SetupEvents();
    }

    private SetupEvents() {
        if ($(".slider").length > 0) {
            tns({
                container: '.slider',
                autoplay: false,
                controls: false,
                nav: true,
                navPosition: "bottom",
                arrowKeys: true
            });
        }

        
        const $iframeContainer = $("#zinio-iframe-container");

        if ($iframeContainer.length > 0) {
            const issueId = $iframeContainer.data("id");
            const host = $iframeContainer.data("host");
            const token = $iframeContainer.data("token");

            // Setup Iframe
            const $iframe = $("<iframe>", {
                src: `${host}#/reader/readsvg/${issueId}`,
                width: "100%",
                height: "100%",
                frameBorder: 0,
                allowFullscreen: true,
            });

            $iframe.on("load", function () {

                // Initialize Reader
                ($iframe.get(0) as HTMLIFrameElement).contentWindow.postMessage({
                    ACCESS_TOKEN: token,
                    USER_ID: "12345"
                },
                    host);
            });

            // Synchronize history
            window.onmessage = function (e) {
                if (e.data && typeof e.data === "string") {
                    window.history.pushState(null, '', e.data);
                }
            };

            $iframeContainer.append($iframe);
        }
    }
}

export const App = new Application();

$(() => {
    WebAppUtils.InitGlobalUtils();

    WebAppUtils.InitInteractionComponents();

    WebAppUtils.SetMobileMenuButtonToggle();

    App.Init();
});